import React from "react";

const NotFound = () => {
  return <div className="section-wrapper">404 Nothing Here</div>;
};

export default NotFound;
